import React, { useEffect, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import {
  Card,
  CardContent,
  Typography,
  FormControlLabel,
  Checkbox,
  FormControl,
  MenuItem,
  InputLabel,
  Collapse,
  RadioGroup,
  Radio,
  FormHelperText,
  Select,
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { CheckCircle, RadioButtonUnchecked } from '@material-ui/icons';
import { isEmpty, get, map, includes, orderBy } from 'lodash';
import { Autocomplete } from '@material-ui/lab';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import messages from 'containers/PreOpeningPage/messages';
import { translate, arrayTranslate } from 'containers/services/translate';
import {
  Container,
  Title,
  GridWrapper,
  StyledTextField,
  StyledKeyboardDatePicker,
  StyledSelect,
} from 'containers/PreOpeningPage/ClaimInformation/style';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import {
  CLAIM,
  VEHICULE,
  EMPTY_VEHICULE,
  VICTIM,
  CLAIM_STATUS,
} from 'containers/data-structure';
import {
  Listings,
  SagisConfig,
  CodesConfig,
  Config,
} from 'containers/AppContainer/typings';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import {
  CHOICE,
  INJURY_POST,
  CHOICES,
} from 'containers/PreOpeningPage/constants';
import { shouldDisableInput } from 'containers/PreOpeningPage/utils';
import ClaimInformationModificationDrawer from 'containers/RecapManagerPage/ClaimInformationModificationDrawer';
import frLocale from 'date-fns/locale/fr';
import {
  getCountriesWithCities,
  shouldDisplayEditButtonClaim,
} from 'containers/RecapManagerPage/utils';
import validate from 'containers/services/validateForm';
import { displayErrorText } from 'containers/services/validateForm';
import { formatNumberInput } from 'containers/services/formatNumberInput';
import { filterVisibleOnly } from 'containers/services/filters';
import { getCities } from 'containers/RecapManagerPage/utils';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { getProp } from 'containers/common/LegalProceedings/utils';
import { isOpeningManager } from 'containers/AppContainer/utils';
import { OPENING_STATE, OPENING_TYPE } from 'services/constants';

export const claimInformationConstraints = (
  claim: any,
  isModification?: boolean,
  isOpeningManager?: boolean,
  isUsageOpening?: boolean,
) => {
  const YesNo = isModification ? CHOICES : CHOICE;
  const commonConstraints = {
    [CLAIM.LOSS_HOUR]: {
      presence: true,
      format: {
        pattern: /^$|^\d{2}:\d{2}$/,
        message: messages.lossHourErrorMessage,
      },
    },
    [CLAIM.LOSS_DATE]: {
      presence: true,
    },
    [CLAIM.PV_NUMBER]: {
      presence: !isUsageOpening ? true : false,
      length: !isUsageOpening
        ? { maximum: 30, message: messages.fieldLengthError }
        : {},
    },
    [CLAIM.LOSS_DATE]: {
      presence: true,
    },
    [CLAIM.LOSS_LOCATION]: {
      presence: true,
    },
    [CLAIM.TOTAL_INJURED_VICTIMS]: {
      presence: !isModification && !isUsageOpening ? true : false,
    },
    [CLAIM.TOTAL_DECEASED_VICTIMS]: {
      presence: !isModification && !isUsageOpening ? true : false,
    },
    [CLAIM.AUTHORITY_TYPE]: {
      presence: !isUsageOpening ? true : false,
    },
    [CLAIM.AUTHORITY_NAME]: {
      presence: !isUsageOpening ? true : false,
      length: !isUsageOpening
        ? { maximum: 30, message: messages.fieldLengthError }
        : {},
    },
    [CLAIM.COUNTRY_ID]: {
      presence: true,
    },
    [CLAIM.FIRM_REFERENCE]: {
      presence: isOpeningManager || isUsageOpening ? false : true,
      length:
        isOpeningManager || isUsageOpening
          ? {}
          : {
              maximum: 30,
              message: messages.fieldLengthError,
            },
    },
    [CLAIM.JURISDICTION_ID]: {
      presence: featureService.hasFeature(
        FEATURES.ASSIGNMENT_JURISDICTION_LAWYER,
      ),
    },
  };
  if (!featureService.hasFeature(FEATURES.OPPOSING_PARTY)) {
    return {
      ...commonConstraints,
      [CLAIM.HAS_MATERIAL_DAMAGES]: {
        presence: !isUsageOpening ? true : false,
      },
      [VEHICULE.BRAND]: {
        presence: get(claim, [CLAIM.HAS_MATERIAL_DAMAGES], '') === YesNo.YES,
      },
      [VEHICULE.REGISTRATION_NUMBER]: {
        presence: get(claim, [CLAIM.HAS_MATERIAL_DAMAGES], '') === YesNo.YES,
      },
      [VEHICULE.OPPOSING_PARTY]: {
        presence: get(claim, [CLAIM.HAS_MATERIAL_DAMAGES], '') === YesNo.YES,
      },
    };
  }
  return commonConstraints;
};

export const claimInformationValidator = (
  claimToPreopen: any,
  isModification?: boolean,
) => {
  return validate(
    { ...claimToPreopen.claim, ...claimToPreopen.vehicule },
    claimInformationConstraints(
      claimToPreopen.claim,
      isModification,
      isOpeningManager(),
      claimToPreopen.isUsageOpening,
    ),
  );
};

export interface ClaimInformationProps {
  intl: IntlShape;
  updateFilde?: Function;
  claimToPreopen: any;
  changeInjured?: Function;
  inputProps?: any;
  disableInput?: boolean;
  inputLabelProps?: boolean;
  listings?: Listings;
  storedClaimToPreopen?: any;
  setClaimRecap?: Function | undefined;
  claimInformationsValidation?: any;
  isRecapPage: boolean;
  isManager: boolean;
  isReadOnly: boolean;
  policyInfo?: any;
  stakeholders: any;
  missionInfo?: any;
  isLawyer?: boolean;
  setDataClaimToUpdate?: Function;
  dataClaimToUpdate?: any;
  shouldDisplayAllClaimInfo?: boolean;
  isCourtManager?: boolean;
  disableJurisdiction?: boolean;
  readInfoSagis?: boolean;
  sagisInfoClaim?: any;
  isOpeningManager?: boolean;
  requestSearchClaims?: Function;
  foundClaims?: any;
  requestClaimRecap?: Function;
  isBasicManagement?: boolean;
  isCourtManagerBasicManagement?: boolean;
  location?: any;
}

const ClaimInformation: React.FC<ClaimInformationProps> = (
  props,
): JSX.Element => {
  const isRejected =
    get(props.storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.REJECTED;
  const isValidated =
    get(props.storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.VALIDATED;
  const isValidatedCorpo =
    get(props.storedClaimToPreopen, 'claim.status') ===
    CLAIM_STATUS.PENDING_APPROVAL;
  useEffect(() => {
    const state = { ...props.claimToPreopen };
    if (isEmpty(state.vehicule) && !props.isBasicManagement) {
      state.vehicule = { ...EMPTY_VEHICULE };
      props.updateFilde && props.updateFilde(state);
    }
  });
  const [isModificationDrawerOpen, setIsModificationDrawerOpen] = useState(
    false,
  );

  const inputLabel = React.useRef<HTMLLabelElement>(null);

  const filtredCompanies = (
    companies: SagisConfig[],
    filter: CodesConfig[],
  ) => {
    const filterCodes = map(filter, 'code');
    const filtredCompanies = companies.filter(({ ItemKey }) =>
      filterCodes.includes(ItemKey),
    );
    return filtredCompanies;
  };

  const handleLossHourChange = (event: any) => {
    const { value } = event.target || '';

    const time = value.replace(':', '');
    const [hours, minutes] = [time.slice(0, 2), time.slice(2, 4)];
    const [hoursForTest, minutesForTest] = [hours, minutes].map((t: any) =>
      t && t.length < 2 ? t * 10 : t,
    );
    if (hoursForTest < 24 && (!minutes || minutesForTest < 60)) {
      handleChange(CLAIM.LOSS_HOUR)(
        event as any,
        [hours, minutes].filter(t => !!t).join(':'),
      );
    }
  };

  const handleChange = (field: string) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
    valueField?: any,
  ) => {
    const { value } = event.target;

    const claimToPreopen = !isEmpty(props.storedClaimToPreopen)
      ? { ...props.storedClaimToPreopen }
      : { ...props.claimToPreopen };

    const { vehicule, claim } = claimToPreopen;

    switch (field) {
      case CLAIM.PV_NUMBER:
        claim[CLAIM.PV_NUMBER] = value;
        break;
      case CLAIM.LOSS_LOCATION:
        claim[CLAIM.LOSS_LOCATION] = get(valueField, 'ItemKey');
        break;
      case CLAIM.TOTAL_INJURED_VICTIMS:
        claim[CLAIM.TOTAL_INJURED_VICTIMS] = formatNumberInput(value);
        break;
      case CLAIM.TOTAL_DECEASED_VICTIMS:
        claim[CLAIM.TOTAL_DECEASED_VICTIMS] = formatNumberInput(value);
        break;
      case CLAIM.AUTHORITY_TYPE:
        claim[CLAIM.AUTHORITY_TYPE] = value;
        break;
      case CLAIM.AUTHORITY_NAME:
        claim[CLAIM.AUTHORITY_NAME] = value;
        break;
      case CLAIM.HAS_MATERIAL_DAMAGES:
        claim[CLAIM.HAS_MATERIAL_DAMAGES] = value;
        break;
      case VEHICULE.BRAND:
        vehicule[VEHICULE.BRAND] = get(valueField, 'ItemKey');
        break;
      case VEHICULE.OPPOSING_PARTY:
        vehicule[VEHICULE.OPPOSING_PARTY] = value;
        break;
      case VEHICULE.REGISTRATION_NUMBER:
        vehicule[VEHICULE.REGISTRATION_NUMBER] = value;
        break;
      case CLAIM.LOSS_HOUR:
        claim[CLAIM.LOSS_HOUR] = valueField;
        break;
      case CLAIM.COUNTRY_ID:
        claim[CLAIM.COUNTRY_ID] = value;
        claim[CLAIM.LOSS_LOCATION] = null;
        break;
      case CLAIM.FIRM_REFERENCE:
        claim[CLAIM.FIRM_REFERENCE] = value;
        break;
      case CLAIM.JURISDICTION_ID:
        claim[CLAIM.JURISDICTION_ID] = value;
        break;
      default:
        return claimToPreopen;
    }
    props.updateFilde && props.updateFilde(claimToPreopen);
  };

  const getMaterialDamageRecapLabel = () => {
    const yes = translate({ ...messages.yes }, props);
    const no = translate({ ...messages.no }, props);
    if (props.isManager) {
      return !isEmpty(vehicule) ? yes : no;
    }

    return get(claim, [CLAIM.HAS_MATERIAL_DAMAGES], '') === CHOICE.YES
      ? yes
      : no;
  };
  let value = !isEmpty(props.storedClaimToPreopen)
    ? { ...props.storedClaimToPreopen }
    : props.claimToPreopen;

  const { claim, vehicule } = value;
  const isOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISOPENINGMANAGER,
  );
  const isCourtManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISCOURTMANAGER,
  );
  const isPreOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISPREOPENMANAGER,
  );

  const updateFormByProfile = () => {
    if (
      props.isManager ||
      (props.isLawyer && isRejected) ||
      props.isCourtManager
    ) {
      return handleToggleModificationDrawer();
    }
    return isOpeningManager
      ? pushTo(PAGES.OPENING_CLAIM)()
      : isCourtManager
      ? pushTo(PAGES.PREOPENING_MANAGER, {
          isFromSagis: true,
          sagisInfoClaim: get(props, 'location.state.sagisInfoClaim'),
        })()
      : isPreOpeningManager
      ? pushTo(PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER, {
          isUsageOpening: get(props, 'location.state.isUsageOpening', false),
        })()
      : pushTo(PAGES.PREOPENING)();
  };

  const handleToggleModificationDrawer = (isCancel: boolean = false) => {
    setIsModificationDrawerOpen(!isModificationDrawerOpen);
    props.requestClaimRecap &&
      isCancel &&
      props.requestClaimRecap(get(value, 'claim.id'));
  };

  const brand = () => {
    if (props.listings && props.listings.vehicleBrands)
      return props.listings.vehicleBrands.find(
        e => e.ItemKey === get(vehicule, [VEHICULE.BRAND]),
      );
    return {} as SagisConfig;
  };
  const lossLocation = () => {
    if (props.listings && props.listings.villes)
      return props.listings.villes.find(
        e => e.ItemKey === get(claim, [CLAIM.LOSS_LOCATION]),
      );
    return {} as SagisConfig;
  };

  const numberOfXVictims = (X: string[]) => {
    return get(value, 'victims', []).filter(
      (e: any) => includes(X, e[VICTIM.INJURY_POST_KEY]) && !e.isDeleted,
    ).length;
  };

  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);
  const { message } = displayErrorText(
    props.claimInformationsValidation,
    translateArrayErrorMessages(props.claimInformationsValidation, true),
  );

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option: SagisConfig) => option?.ItemDescription,
  });

  const countries: SagisConfig[] = getCountriesWithCities(
    get(props.listings, 'country', []),
    get(props.listings, 'villes', []),
  );
  return (
    <Container className="container">
      <Card>
        <CardContent>
          <Title variant="h1" gutterBottom>
            {translate({ ...messages.claimInformationTitle }, props)}
          </Title>
          {shouldDisplayEditButtonClaim(
            props.isRecapPage,
            props.isManager,
            props.isReadOnly,
            value,
            isRejected,
            props.isLawyer,
            props.isCourtManager,
            props.isOpeningManager,
          ) &&
            (isValidated && isOpeningManager
              ? featureService.hasFeature(
                  FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
                )
              : true) &&
            (props.isCourtManager
              ? featureService.hasFeature(FEATURES.UPDATE_CLAIM_COURT_MANAGER)
              : true) &&
            !isValidatedCorpo && (
              <SecondaryButton
                variant="contained"
                onClick={updateFormByProfile}
                title={translate({ ...messages.updateBtnLabel }, props)}
              />
            )}
          <GridWrapper>
            <Grid container spacing={5}>
              {!props.shouldDisplayAllClaimInfo && (
                <Grid item xs={3}>
                  <StyledTextField
                    id="standard-basic-1"
                    onChange={handleChange(CLAIM.PV_NUMBER)}
                    name={CLAIM.PV_NUMBER}
                    value={get(claim, [CLAIM.PV_NUMBER])}
                    label={translate({ ...messages.pvNumero }, props)}
                    InputProps={props.inputProps}
                    disabled={props.disableInput}
                    InputLabelProps={{ shrink: props.inputLabelProps }}
                    error={
                      !!get(props.claimInformationsValidation, [
                        CLAIM.PV_NUMBER,
                      ])
                    }
                    helperText={message[CLAIM.PV_NUMBER]}
                    fullWidth
                  />
                </Grid>
              )}
              {!props.shouldDisplayAllClaimInfo && (
                <Grid item xs={3}>
                  <FormControl
                    error={
                      !!get(props.claimInformationsValidation, [
                        CLAIM.COUNTRY_ID,
                      ])
                    }
                    fullWidth
                  >
                    <InputLabel
                      ref={inputLabel}
                      id="demo-simple-select-outlined-label"
                    >
                      {translate({ ...messages.country }, props)}
                    </InputLabel>
                    <StyledSelect
                      onChange={handleChange(CLAIM.COUNTRY_ID)}
                      name={CLAIM.COUNTRY_ID}
                      value={
                        props.readInfoSagis && props.sagisInfoClaim
                          ? String(
                              get(
                                get(props.listings, 'villes', [])?.find(
                                  (item: any) =>
                                    item.ItemDescription?.toUpperCase() ===
                                    get(
                                      props.sagisInfoClaim,
                                      'lossLocation',
                                    )?.toUpperCase(),
                                ),
                                'ItemGroup',
                                '',
                              ),
                            )
                          : get(claim, [CLAIM.COUNTRY_ID], '')
                      }
                      disabled={shouldDisableInput(
                        props.disableInput,
                        props.isCourtManagerBasicManagement,
                        get(claim, [CLAIM.COUNTRY_ID], null),
                      )}
                      fullWidth
                    >
                      {!isEmpty(countries) &&
                        countries.map((country: SagisConfig) => (
                          <MenuItem
                            value={country.ItemKey}
                            key={country.ItemKey}
                          >
                            {country.ItemDescription}
                          </MenuItem>
                        ))}
                    </StyledSelect>
                    {!!get(props.claimInformationsValidation, [
                      CLAIM.COUNTRY_ID,
                    ]) && (
                      <FormHelperText className="errorSelect">
                        {message[CLAIM.COUNTRY_ID]}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              )}
              {!isEmpty(get(claim, [CLAIM.LOSS_LOCATION])) ? (
                <Grid item xs={3}>
                  <StyledTextField
                    id="standard-basic-1"
                    name={CLAIM.LOSS_LOCATION}
                    value={
                      props.readInfoSagis && props.sagisInfoClaim
                        ? get(props.sagisInfoClaim, 'lossLocation', null)
                        : get(lossLocation(), 'ItemDescription', '')
                    }
                    label={translate({ ...messages.claimPlace }, props)}
                    disabled={shouldDisableInput(
                      props.disableInput,
                      props.isCourtManagerBasicManagement,
                      get(claim, [CLAIM.LOSS_LOCATION], null),
                    )}
                    InputProps={props.inputProps}
                    fullWidth
                  />
                </Grid>
              ) : (
                <Grid item xs={3}>
                  <Autocomplete
                    id="standard-basic-2"
                    options={getCities(
                      get(props.listings, 'villes', []),
                      claim[CLAIM.COUNTRY_ID],
                    )}
                    value={lossLocation()}
                    defaultValue={lossLocation()}
                    getOptionLabel={(city: SagisConfig) =>
                      get(city, 'ItemDescription', '')
                    }
                    autoSelect={true}
                    onChange={handleChange(CLAIM.LOSS_LOCATION)}
                    filterOptions={filterOptions}
                    disabled={shouldDisableInput(
                      props.disableInput,
                      props.isCourtManagerBasicManagement,
                      get(claim, [CLAIM.LOSS_LOCATION], null),
                    )}
                    renderInput={params => (
                      <StyledTextField
                        {...params}
                        name={CLAIM.LOSS_LOCATION}
                        label={translate({ ...messages.claimPlace }, props)}
                        disabled={props.disableInput}
                        error={
                          !!get(props.claimInformationsValidation, [
                            CLAIM.LOSS_LOCATION,
                          ])
                        }
                        helperText={message[CLAIM.LOSS_LOCATION]}
                      />
                    )}
                    fullWidth
                  />
                </Grid>
              )}
              {featureService.hasFeature(
                FEATURES.ASSIGNMENT_JURISDICTION_LAWYER,
              ) &&
                !props.disableJurisdiction && (
                  <Grid item xs={3}>
                    <FormControl
                      fullWidth
                      error={
                        !!get(props.claimInformationsValidation, [
                          CLAIM.JURISDICTION_ID,
                        ])
                      }
                    >
                      <InputLabel id="jurisdiction-label-id">
                        {translate(messages.jurisdiction, props)}
                      </InputLabel>
                      <Select
                        labelId="jurisdiction-label-id"
                        onChange={handleChange(CLAIM.JURISDICTION_ID)}
                        name={CLAIM.JURISDICTION_ID}
                        value={get(claim, [CLAIM.JURISDICTION_ID], '')}
                        disabled={props.disableInput}
                      >
                        {orderBy(
                          get(props.listings, 'jurisdiction', []),
                          [el => el?.title?.toLowerCase()],
                          ['asc'],
                        ).map((el: Config) => (
                          <MenuItem key={el.id} value={el.id}>
                            {el.title}
                          </MenuItem>
                        ))}
                      </Select>
                      {!!get(props.claimInformationsValidation, [
                        CLAIM.JURISDICTION_ID,
                      ]) && (
                        <FormHelperText className="errorSelect">
                          {message[CLAIM.JURISDICTION_ID]}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                )}
              <Grid item xs={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                  <StyledKeyboardDatePicker
                    autoOk
                    variant="inline"
                    invalidDateMessage={
                      get(claim, [CLAIM.LOSS_DATE], '') === 'Invalid date'
                        ? translate(messages.invalidDate, props)
                        : ''
                    }
                    format="dd/MM/yyyy"
                    id="date-picker-inline-claim-loss-date"
                    onChange={() => null}
                    name={CLAIM.LOSS_DATE}
                    value={dateStringToLocalDate(
                      get(claim, [CLAIM.LOSS_DATE], ''),
                    )}
                    label={translate({ ...messages.claimDate }, props)}
                    InputProps={props.inputProps}
                    disabled
                    InputLabelProps={{
                      shrink:
                        props.inputLabelProps ||
                        !!get(claim, [CLAIM.LOSS_DATE], ''),
                      classes: { root: 'label-input' },
                    }}
                    fullWidth
                  />
                </MuiPickersUtilsProvider>
              </Grid>

              <Grid item xs={3}>
                <StyledTextField
                  id="date-picker-claim-loss-hour"
                  onChange={handleLossHourChange}
                  name={CLAIM.LOSS_HOUR}
                  value={
                    props.readInfoSagis && props.sagisInfoClaim
                      ? getProp(props.sagisInfoClaim, 'lossTime')
                      : getProp(claim, CLAIM.LOSS_HOUR)
                  }
                  label={translate({ ...messages.claimHour }, props)}
                  placeholder="HH:MM"
                  InputProps={props.inputProps}
                  disabled={shouldDisableInput(
                    props.disableInput,
                    props.isCourtManagerBasicManagement,
                    get(claim, [CLAIM.LOSS_HOUR], null),
                  )}
                  InputLabelProps={{ shrink: props.inputLabelProps }}
                  error={
                    !!get(props.claimInformationsValidation, [CLAIM.LOSS_HOUR])
                  }
                  helperText={message[CLAIM.LOSS_HOUR]}
                  fullWidth
                />
              </Grid>
              {!props.shouldDisplayAllClaimInfo && (
                <Grid item xs={3}>
                  <StyledTextField
                    id="standard-basic-5"
                    type="number"
                    onChange={handleChange(CLAIM.TOTAL_INJURED_VICTIMS)}
                    name={CLAIM.TOTAL_INJURED_VICTIMS}
                    value={
                      !props.isRecapPage
                        ? get(claim, [CLAIM.TOTAL_INJURED_VICTIMS])
                        : numberOfXVictims(INJURY_POST.INJURED)
                    }
                    label={translate({ ...messages.injuredVictims }, props)}
                    InputProps={props.inputProps}
                    disabled={
                      shouldDisableInput(
                        props.disableInput,
                        props.isCourtManagerBasicManagement,
                        get(claim, [CLAIM.TOTAL_INJURED_VICTIMS]),
                        get(claim, [CLAIM.TOTAL_INJURED_VICTIMS]) === 0,
                      ) ||
                      ((get(props.claimToPreopen, 'isUsageOpening', false) ||
                        get(
                          props,
                          'storedClaimToPreopen.isUsageOpening',
                          false,
                        )) &&
                        get(claim, [CLAIM.OPENING_STATE]) !=
                          OPENING_STATE.NOT_COMPLETED)
                    }
                    InputLabelProps={{ shrink: props.inputLabelProps }}
                    error={
                      !!get(props.claimInformationsValidation, [
                        CLAIM.TOTAL_INJURED_VICTIMS,
                      ])
                    }
                    helperText={message[CLAIM.TOTAL_INJURED_VICTIMS]}
                    fullWidth
                  />
                </Grid>
              )}
              {!props.shouldDisplayAllClaimInfo && (
                <Grid item xs={3}>
                  <StyledTextField
                    id="standard-basic-6"
                    type="number"
                    onChange={handleChange(CLAIM.TOTAL_DECEASED_VICTIMS)}
                    name={CLAIM.TOTAL_DECEASED_VICTIMS}
                    value={
                      !props.isRecapPage
                        ? get(claim, [CLAIM.TOTAL_DECEASED_VICTIMS])
                        : numberOfXVictims(INJURY_POST.DECEASED)
                    }
                    label={translate({ ...messages.deceasedVictims }, props)}
                    InputProps={props.inputProps}
                    disabled={
                      shouldDisableInput(
                        props.disableInput,
                        props.isCourtManagerBasicManagement,
                        get(claim, [CLAIM.TOTAL_DECEASED_VICTIMS]),
                        get(claim, [CLAIM.TOTAL_DECEASED_VICTIMS]) === 0,
                      ) ||
                      ((get(props.claimToPreopen, 'isUsageOpening', false) ||
                        get(
                          props,
                          'storedClaimToPreopen.isUsageOpening',
                          false,
                        )) &&
                        get(claim, [CLAIM.OPENING_STATE]) !=
                          OPENING_STATE.NOT_COMPLETED)
                    }
                    InputLabelProps={{ shrink: props.inputLabelProps }}
                    error={
                      !!get(props.claimInformationsValidation, [
                        CLAIM.TOTAL_DECEASED_VICTIMS,
                      ])
                    }
                    helperText={message[CLAIM.TOTAL_DECEASED_VICTIMS]}
                    fullWidth
                  />
                </Grid>
              )}
              {!props.shouldDisplayAllClaimInfo && (
                <Grid item xs={3}>
                  <FormControl
                    error={
                      !!get(props.claimInformationsValidation, [
                        CLAIM.AUTHORITY_TYPE,
                      ])
                    }
                    fullWidth
                  >
                    <InputLabel
                      ref={inputLabel}
                      id="demo-simple-select-outlined-label"
                    >
                      {translate({ ...messages.authorityType }, props)}
                    </InputLabel>
                    <StyledSelect
                      onChange={handleChange(CLAIM.AUTHORITY_TYPE)}
                      name={CLAIM.AUTHORITY_TYPE}
                      value={get(claim, [CLAIM.AUTHORITY_TYPE], '')}
                      disabled={props.disableInput}
                      fullWidth
                    >
                      {!isEmpty(get(props.listings, 'authorityTypes', [])) &&
                        filterVisibleOnly(props.listings!.authorityTypes).map(
                          type => (
                            <MenuItem value={type.id} key={type.id}>
                              {type.title}
                            </MenuItem>
                          ),
                        )}
                    </StyledSelect>
                    {!!get(props.claimInformationsValidation, [
                      CLAIM.AUTHORITY_TYPE,
                    ]) && (
                      <FormHelperText className="errorSelect">
                        {message[CLAIM.AUTHORITY_TYPE]}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              )}
              {!props.shouldDisplayAllClaimInfo && (
                <Grid item xs={3}>
                  <StyledTextField
                    id="standard-basic-8"
                    label={translate({ ...messages.authorityName }, props)}
                    onChange={handleChange(CLAIM.AUTHORITY_NAME)}
                    name={CLAIM.AUTHORITY_NAME}
                    value={get(claim, [CLAIM.AUTHORITY_NAME])}
                    InputProps={props.inputProps}
                    disabled={props.disableInput}
                    InputLabelProps={{ shrink: props.inputLabelProps }}
                    error={
                      !!get(props.claimInformationsValidation, [
                        CLAIM.AUTHORITY_NAME,
                      ])
                    }
                    helperText={message[CLAIM.AUTHORITY_NAME]}
                    fullWidth
                  />
                </Grid>
              )}
              {!isEmpty(get(claim, [CLAIM.CLAIM_NUMBER])) && props.isRecapPage && (
                <Grid item xs={3}>
                  <StyledTextField
                    id="standard-basic-1"
                    name={CLAIM.CLAIM_NUMBER}
                    value={get(claim, [CLAIM.CLAIM_NUMBER])}
                    label={translate({ ...messages.claimNumber }, props)}
                    InputLabelProps={{ shrink: props.inputLabelProps }}
                    helperText={message[CLAIM.CLAIM_NUMBER]}
                    disabled={true}
                    InputProps={props.inputProps}
                    fullWidth
                  />
                </Grid>
              )}
              {!props.isRecapPage && !isOpeningManager && (
                <Grid item xs={3}>
                  <StyledTextField
                    id="standard-basic-1"
                    name={CLAIM.FIRM_REFERENCE}
                    value={get(claim, [CLAIM.FIRM_REFERENCE])}
                    onChange={handleChange(CLAIM.FIRM_REFERENCE)}
                    label={translate({ ...messages.firmReference }, props)}
                    InputProps={props.inputProps}
                    InputLabelProps={{ shrink: props.inputLabelProps }}
                    helperText={message[CLAIM.FIRM_REFERENCE]}
                    fullWidth
                    disabled={props.disableInput}
                    error={
                      !!get(props.claimInformationsValidation, [
                        CLAIM.FIRM_REFERENCE,
                      ])
                    }
                  />
                </Grid>
              )}
              {props.isRecapPage && (
                <Grid item xs={3}>
                  <FormControl fullWidth>
                    <InputLabel id="idd-label-id">
                      {translate(messages.assignedLawyerTitle, props)}
                    </InputLabel>
                    <StyledSelect
                      disabled={true}
                      labelId="idd-label-id"
                      value={get(claim, 'assignment.assignedLawyer')}
                      fullWidth
                    >
                      {props.stakeholders &&
                        props.stakeholders.map(
                          (element: {
                            ItemKey: number;
                            ItemDescription: string;
                          }) => (
                            <MenuItem value={element.ItemKey}>
                              {element.ItemDescription}
                            </MenuItem>
                          ),
                        )}
                    </StyledSelect>
                  </FormControl>
                </Grid>
              )}
              {props.missionInfo && (
                <Grid item xs={3}>
                  <StyledTextField
                    id="standard-basic-1"
                    name={'legalExpert'}
                    value={get(props.missionInfo, 'legalExpert')}
                    label={translate({ ...messages.judiciaryExpert }, props)}
                    InputProps={props.inputProps}
                    InputLabelProps={{ shrink: props.inputLabelProps }}
                    fullWidth
                    disabled={true}
                  />
                </Grid>
              )}
            </Grid>
          </GridWrapper>
          {!featureService.hasFeature(FEATURES.OPPOSING_PARTY) && (
            <div className="checkdiv">
              <Typography className="text">
                {translate({ ...messages.materialDamages }, props)}
              </Typography>
              {!props.isRecapPage ? (
                <FormControl>
                  <RadioGroup
                    row
                    onChange={handleChange(CLAIM.HAS_MATERIAL_DAMAGES)}
                    value={get(claim, [CLAIM.HAS_MATERIAL_DAMAGES], '')}
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          color="primary"
                          value={CHOICE.YES}
                          checkedIcon={<CheckCircle />}
                        />
                      }
                      label={translate({ ...messages.yes }, props)}
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          color="primary"
                          value={CHOICE.NO}
                          checkedIcon={<CheckCircle />}
                        />
                      }
                      label={translate({ ...messages.no }, props)}
                    />
                  </RadioGroup>
                  {!!get(props.claimInformationsValidation, [
                    CLAIM.HAS_MATERIAL_DAMAGES,
                  ]) && (
                    <FormHelperText className="error">
                      {message[CLAIM.HAS_MATERIAL_DAMAGES]}
                    </FormHelperText>
                  )}
                </FormControl>
              ) : (
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={true}
                      checkedIcon={<CheckCircle />}
                      icon={<RadioButtonUnchecked />}
                      disabled={props.disableInput}
                    />
                  }
                  label={getMaterialDamageRecapLabel()}
                />
              )}
            </div>
          )}
          <Collapse
            in={
              props.isRecapPage && props.isManager
                ? !isEmpty(vehicule)
                : get(claim, [CLAIM.HAS_MATERIAL_DAMAGES]) === CHOICE.YES
            }
          >
            <div className="subContainer">
              <Autocomplete
                id="standard-basic-xx"
                className="input-3"
                options={get(props.listings, 'vehicleBrands', [])}
                getOptionLabel={(brand: SagisConfig) => brand.ItemDescription}
                value={brand()}
                autoSelect={true}
                onChange={handleChange(VEHICULE.BRAND)}
                filterOptions={filterOptions}
                disabled={props.disableInput}
                renderInput={params => (
                  <StyledTextField
                    {...params}
                    name={VEHICULE.BRAND}
                    label={translate(
                      { ...messages.claimInformationVehicleBrand },
                      props,
                    )}
                    disabled={props.disableInput}
                    error={
                      !!get(props.claimInformationsValidation, [VEHICULE.BRAND])
                    }
                    helperText={message[VEHICULE.BRAND]}
                  />
                )}
              />
              <StyledTextField
                label={translate({ ...messages.registration }, props)}
                className="input-3"
                onChange={handleChange(VEHICULE.REGISTRATION_NUMBER)}
                name={VEHICULE.REGISTRATION_NUMBER}
                value={get(vehicule, [VEHICULE.REGISTRATION_NUMBER])}
                disabled={props.disableInput}
                error={
                  !!get(props.claimInformationsValidation, [
                    CLAIM.REGISTRATION_NUMBER,
                  ])
                }
                helperText={message[CLAIM.REGISTRATION_NUMBER]}
              />
              <FormControl
                className="input-3"
                error={
                  !!get(props.claimInformationsValidation, [
                    VEHICULE.OPPOSING_PARTY,
                  ])
                }
              >
                <InputLabel>
                  {translate({ ...messages.opposingCompanies }, props)}
                </InputLabel>
                <StyledSelect
                  onChange={handleChange(VEHICULE.OPPOSING_PARTY)}
                  name={VEHICULE.OPPOSING_PARTY}
                  value={get(vehicule, [VEHICULE.OPPOSING_PARTY], '')}
                  disabled={props.disableInput}
                  fullWidth
                >
                  {!isEmpty(get(props.listings, 'compagnies', [])) &&
                    filtredCompanies(
                      props.listings!.compagnies,
                      props.listings!.insuranceCompanies,
                    ).map(company => (
                      <MenuItem value={company.ItemKey} key={company.ItemKey}>
                        {company.ItemDescription}
                      </MenuItem>
                    ))}
                </StyledSelect>
                {!!get(props.claimInformationsValidation, [
                  VEHICULE.OPPOSING_PARTY,
                ]) && (
                  <FormHelperText className="errorSelect">
                    {message[VEHICULE.OPPOSING_PARTY]}
                  </FormHelperText>
                )}
              </FormControl>
            </div>
          </Collapse>
        </CardContent>
      </Card>
      {isModificationDrawerOpen && (
        <ClaimInformationModificationDrawer
          open={isModificationDrawerOpen}
          handleToggleDrawer={handleToggleModificationDrawer}
          authorityTypes={get(props.listings, 'authorityTypes', [])}
          vehicleBrands={get(props.listings, 'vehicleBrands', [])}
          compagnies={get(props.listings, 'compagnies', [])}
          insuranceCompanies={get(props.listings, 'insuranceCompanies', [])}
          countries={countries}
          claimToPreopen={value}
          setClaimRecap={props.setClaimRecap}
          cities={get(props.listings, 'villes', [])}
          jurisdictions={orderBy(
            get(props.listings, 'jurisdiction', []),
            [el => el?.title?.toLowerCase()],
            ['asc'],
          )}
          setDataClaimToUpdate={props.setDataClaimToUpdate}
          dataClaimToUpdate={props.dataClaimToUpdate}
          policyInfo={props.policyInfo}
          requestSearchClaims={props.requestSearchClaims}
          foundClaims={props.foundClaims}
        ></ClaimInformationModificationDrawer>
      )}
    </Container>
  );
};
export default injectIntl(ClaimInformation);
